<template>
  <div v-if="maxSmall" class="bg-alpha-white-10 rounded-md">
    <Indicator
      variant="building"
      size="md"
      mode="solid"
      :isGroup="selected.id === 'all'"
      :imageUrl="selected?.imageUrl"
      @click.stop="handleClick"
      alpha
    />
  </div>

  <div
    v-else
    class="group flex items-center p-[3px] md:p-2 lrt:pr-3 ltr:md:pr-4 rtl:pl-3 rtl:md:pl-4 gap-2 md:gap-3 group-data-[collapsed=true]/nav:md:px-1 group-data-[collapsed=true]/nav:md:justify-center group-data-[collapsed=true]/nav:md:py-3"
    :class="{ 'hover:md:cursor-pointer': !disabled }"
    @click.stop="handleClick"
  >
    <Indicator
      variant="building"
      size="md"
      mode="solid"
      :isGroup="selected.id === 'all'"
      :imageUrl="selected?.imageUrl"
      @click.stop="handleClick"
      alpha
    />
    <div
      class="flex flex-col items-start justify-center grow -gap-0.5 overflow-hidden group-data-[collapsed=true]/nav:md:hidden"
    >
      <span
        :title="selected.name"
        class="w-full text-style-base md:text-style-sm font-medium md:font-semibold text-primary_on-brand max-md:text-center truncate"
      >
        {{ selected.name }}
      </span>
    </div>
    <Icon
      v-if="!disabled"
      class="hidden md:block w-4 h-4 shrink-0 group-data-[collapsed=true]/nav:md:hidden"
      :class="open ? 'fg-white' : 'text-alpha-white-80 md:group-hover:fg-white'"
      :name="open ? 'chevron-up' : 'chevron-down'"
    />
  </div>
</template>

<script setup>
import { Indicator } from "@/SharedComponents/Indicator";
import { Icon } from "@/SharedComponents/Icon";
import { useBreakpoints } from "@/Composables/useBreakpoints";

const { maxSmall } = useBreakpoints();

const emit = defineEmits(["update:open"]);

const props = defineProps({
  open: { type: Boolean, required: false },
  organisation: { type: String, required: true },
  selected: { type: Object, required: true },
  disabled: { type: Boolean, default: false },
});

const handleClick = () => {
  if (!props.disabled) {
    emit("update:open", !props.open);
  }
};
</script>
